import type { BaseController } from '@infra/controllers/base.controller';
import { InvalidUserLoginRequest } from '@usecases/user-login.usecase';
import type {
  UserUnifiedLoginRequest,
  UserUnifiedLoginUsecase,
} from '../usecases/user-unified-login.usecase';

export type UserUnifiedLoginInput = UserUnifiedLoginRequest;

export type UserUnifiedLoginOutput = InvalidUserLoginRequest | void;

export class UserUnifiedLoginController
  implements BaseController<UserUnifiedLoginInput, UserUnifiedLoginOutput>
{
  constructor(private usecase: UserUnifiedLoginUsecase) {}

  async handle(req: UserUnifiedLoginInput): Promise<UserUnifiedLoginOutput> {
    try {
      await this.usecase.run(req);
    } catch (error) {
      if (error instanceof InvalidUserLoginRequest) {
        return error;
      }

      throw error;
    }
  }
}
